import { getPremiseId } from "./worker";

const prefetchedByAwb = new Map();
let installed = false;

const getAwbFromTrackingUrl = (url) => {
  if (!url || !url.includes("/inscan-service/tracking")) {
    return null;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.searchParams.get("awbNumber");
  } catch {
    const match = url.match(/[?&]awbNumber=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }
};

const getTrackingHeaders = () => {
  const userData = JSON.parse(localStorage.getItem("userinfo") || "{}");
  const currentPremiseId = getPremiseId();
  const premiseIdHeader = currentPremiseId?.includes("Bearer")
    ? currentPremiseId.split("Bearer")[1]?.trim()
    : currentPremiseId?.trim();

  return {
    Authorization: `Bearer ${userData?.accessToken || ""}`,
    token: userData?.accessToken || "",
    "SMCS-PREMISE-ID": premiseIdHeader || "",
    type: "2",
  };
};

const mergeHeaders = (initHeaders = {}, trackingHeaders = {}) => {
  const merged = new Headers(initHeaders);

  Object.entries(trackingHeaders).forEach(([key, value]) => {
    if (value) {
      merged.set(key, String(value));
    }
  });

  return merged;
};

export const registerPrefetchedTrackingData = (awbNumber, data) => {
  if (!awbNumber || !data) {
    return;
  }

  prefetchedByAwb.set(String(awbNumber), data);
};

export const clearPrefetchedTrackingData = (awbNumber) => {
  if (!awbNumber) {
    return;
  }

  prefetchedByAwb.delete(String(awbNumber));
};

export const installTrackingFetchInterceptor = () => {
  if (installed || typeof window === "undefined" || !window.fetch) {
    return;
  }

  installed = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";
    const awb = getAwbFromTrackingUrl(url);

    if (!awb) {
      return originalFetch(input, init);
    }

    if (prefetchedByAwb.has(awb)) {
      return new Response(JSON.stringify(prefetchedByAwb.get(awb)), {
        status: 200,
        headers: { "Content-Type": "application/json" },
      });
    }

    const headers = mergeHeaders(init.headers, getTrackingHeaders());

    if (typeof input === "string") {
      return originalFetch(input, { ...init, headers });
    }

    return originalFetch(input, { ...init, headers });
  };
};
